module.exports = __webpack_public_path__ + "img/visuals-ufK-deiLqY8-unsplash.2758dfdc.png";